import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,

  prepareFilter,
  filterFields,
  filterInitialValues,
} from './BuildingUtils';
import FloorPage from './FloorPage';


import { BuildingUIProvider } from './BuildingUIContext';
import FloorBasePage from './FloorBasePage';



const redirects = [
  {
    exact: true,
    from: "/building",
    to: "/building/building",
  },
  {
    exact: false,
    from: "/building/floors",
    to: "/building/building",
  },
  {
    exact: false,
    from: "/building/rooms",
    to: "/building/building",
  },
];

const BuildingPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.buildings }),
    shallowEqual
  );

  const { floorState } = useSelector(
    (state) => ({ floorState: state.floors }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/building")) {
    const temp = menuList.find(q => q.url == "/building")
    isFullAccess = temp.isFullAccess;
  }

  const otherTabs = [
    { id: 2, title: "مدیریت طبقات", tab: 'floors', component: FloorPage },
    // { id: 3, title: "MODULES.BASEINFO.ROLE.PERMISSION_PLACE", tab: 'auditPlace', component: AuditPlaceAccessPage },
    // { id: 3, title: "پرسشنامه  های مجاز", tab: 'formAccess'},
    // { id: 4, title: "MODULES.BASEINFO.ROLE.PERMISSION_SELF_TYPE", tab: 'selfTypeAccess'},
    // { id: 4, title: "MODULES.BASEINFO.ROLE.PERMISSION_ROLE", tab: 'roleAccess',component:RoleAccessPage},
    // { id: 5, title: "MODULES.BASEINFO.ROLE.PERMISSION_MENU", tab: 'menuAccess',component:MenuAccessPage},
  ];

  return (
    <BuildingUIProvider>
      <FilterObjectsUIProvider initialFilter={filterInitialValues}>
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            {/* {
          <Redirect
            // exact={true}
            from="/building/floors"
            to="/building"
          />

        } */}
            {/* {
          <Redirect
            exact={true}
            from="/building"
            to="/building/building"
          />

        } */}
            {/*
        {
          <Redirect
            // exact={true}
            from="/building/rooms"
            to="/building/building"
          />
        } */}

            {/* // <BaseObjectsPage manuUrl="/buildings" redirectList={redirects} stateName="buildings" basePath="/buildings/buildings" api="api/building" currentState={currentState} initObject={initObject}
    //   formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} 
    //   columns={columns} prepareFilter={prepareFilter} filterFields={filterFields} filterInitialValues={filterInitialValues} /> */}

            <ContentRoute path="/building/new"
              render={props =>
                <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/building" api="api/building" currentState={currentState} initObject={initObject}
                  formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
            />

            <ContentRoute
              path="/building/:id/edit"
              render={props =>
                <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/building" api="api/building" currentState={currentState} initObject={initObject}
                  formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
            />

            <ContentRoute
              path="/building/:id/:buildingTitle/floors"
              render={props =>
                //   <FloorBasePage
                //     {...props}
                //     isFullAccess={isFullAccess}
                //     basePath="/building/floors"
                //     api="api/floor"
                //     prentName="buildingId"
                //     currentState={floorState}
                //     columns={floorColumns}
                //     prepareFilter={floorPrepareFilter}
                //     filterFields={floorFilterFields}
                //     filterInitialValues={floorFilterInitialValues}
                //   />
                // }
                <FloorPage
                  {...props}
                  isFullAccess={isFullAccess}
                  basePath="/building/floors"
                // api="api/BankAccountSubGroup"
                // currentState={attSettingcurrentState}
                // initObject={initObjectAttendance}
                // formFields={attendanceFormFields}
                // otherFields={otherFields}
                // ObjectEditSchema={ObjectEditSchema}
                // prepareFilter={prepareFilter}
                />}
            />

            <ContentRoute
              path="/building"
              render={props => <ObjectsPage  {...props} isFullAccess={isFullAccess} basePath="/building" api="api/building" currentState={currentState}
                columns={columns} prepareFilter={prepareFilter} filterFields={filterFields} filterInitialValues={filterInitialValues} />}
            />

          </Switch>
        </Suspense>
      </FilterObjectsUIProvider>
    </BuildingUIProvider>
  )
}

export default BuildingPage



